export default __webpack_public_path__ + "static/media/animal-35.05a0f752.svg";